import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import Icons from '../../../../assets/icons/icons.json';

@Injectable({
  providedIn: 'root'
})
export class IconsService {

  icons: { icon: any; } = Icons;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,

  ) {

  }


  setIcon() {
    this.icons.icon.others.forEach(i => {

      this.matIconRegistry.addSvgIcon(
        i,
        this.sanitizer.bypassSecurityTrustResourceUrl("../assets/icons/others/" + i + ".svg")
      )
    })
  
    this.icons.icon.sube_icons.forEach(i => {
      this.matIconRegistry.addSvgIcon(
        i,
        this.sanitizer.bypassSecurityTrustResourceUrl('../assets/icons/sube_icons/' + i+ ".svg")
      )
    })

    this.icons.icon.mobil_icons.forEach(i => {
      this.matIconRegistry.addSvgIcon(
        i,
        this.sanitizer.bypassSecurityTrustResourceUrl('../assets/icons/mobil_icons/' + i+ ".svg")
      )
    })
  
  
  }
}
